import { z } from 'zod'

export enum MinCashMethod {
  CashAmount = 'cash_amount',
  Percentage = 'percentage',
}

// Zod schemas for validation
const percentageSchema = z
  .number()
  .min(0, 'Percentage cannot be negative')
  .max(100, 'Percentage cannot exceed 100%')

const cashAmountSchema = z.number().min(0, 'Amount cannot be negative')

/**
 * Validate minimum cash amount based on the selected method
 * @param value - Input value as string
 * @param method - Validation method (cash amount or percentage)
 * @returns Error message or null if valid
 */
export const validateMinCashAmount = (
  value: string,
  method: MinCashMethod,
): string | null => {
  const numValue = parseFloat(value)

  // biome-ignore lint/suspicious/noGlobalIsNan: Bulk suppression as part of biome migration
  if (isNaN(numValue) || value.trim() === '') {
    return 'Please enter a valid number'
  }

  const schema =
    method === MinCashMethod.Percentage ? percentageSchema : cashAmountSchema

  const result = schema.safeParse(numValue)

  if (!result.success) {
    return result.error.errors[0]?.message || 'Invalid value'
  }

  return null
}
